import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-cart-details',
    templateUrl: './cart-details.page.html',
    styleUrls: ['./cart-details.page.scss'],
})
export class CartDetailsPage {

}